import React from "react";
import { Link } from "react-router-dom";
import "./Logo.css";

/**
 * Site logo - renders the image at /public/assets/today-talks-logo.png.
 * Swap that file for your real logo asset (tagline can be baked into the
 * image itself, as in the reference design) - no code changes needed.
 */
function Logo({ size = "default" }) {
  return (
    <Link to="/" className={`tt-logo-wrap tt-logo-${size}`} aria-label="Today Talks - home">
      <img
        src={`/assets/todaytalks.png`}
        alt="Today Talks - Speaking Today, Shaping Tomorrow"
        className="tt-logo-image"
      />
    </Link>
  );
}

export default Logo;
